import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WeightLoss = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <div className="service-detail-page">
      {/* Hero Section */}
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <TrendingUp size={64} className="service-hero-icon" />
            <h1 className="display-large">Weight Loss Programs</h1>
            <p className="body-large">
              Achieve sustainable fat loss through evidence-based training and personalized 
              nutrition guidance tailored to your lifestyle.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">
                Book Free Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img 
                src="https://images.pexels.com/photos/6551068/pexels-photo-6551068.jpeg" 
                alt="Weight Loss Progress Tracking" 
              />
            </div>
            
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">Transform Your Body</h2>
              <p className="body-medium">
                Losing weight isn't just about eating less and moving more. It's about creating 
                sustainable habits, understanding your body, and having the right support system. 
                My weight loss programs focus on realistic, long-term results that you can maintain.
              </p>
              
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Customized Calorie Targets</h4>
                      <p className="body-small">Personalized macronutrient goals that fit your lifestyle and preferences</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Metabolic Conditioning</h4>
                      <p className="body-small">Strategic workouts designed to maximize fat burning</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Weekly Progress Tracking</h4>
                      <p className="body-small">Regular check-ins and adjustments to keep you on track</p>
                    </div>
                  </div>
                  
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Lifestyle & Habit Coaching</h4>
                      <p className="body-small">Build sustainable habits that last beyond the program</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Start Your Weight Loss Journey</h2>
            <p className="body-large">
              Let's create a sustainable plan that delivers real, lasting results.
            </p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">
                  Book Free Consultation
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
              <Link to="/services">
                <Button className="btn-secondary">
                  View All Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WeightLoss;
